module.exports = __webpack_public_path__ + "img/clouds-bottom-background.482122ba.jpg";